<section class="page-wrap animated fadeIn position-relative">

  <header class="pattern-header">
    PRIVACY POLICY
  </header>

  <div class="container">

    <p class="h6-semibold">
      Carlton Farms is committed to protecting the privacy and security of the information you share with us.
    </p>

    <p class="h6-semibold">
      This privacy policy has been compiled to better serve those who are concerned with how their personally
      identifiable
      information is being used online. Personally identifiable information, as used in US privacy law and information
      security, is information that can be used on its own or with other information to identify, contact, or locate a
      single person, or to identify an individual in context. Please read our privacy policy to get a clear
      understanding
      of how we collect, use, protect or otherwise handle your Personally Identifiable Information in accordance with
      our
      website.
    </p>

    <h4 class="h4-bold">
      Information we collect
    </h4>

    <p class="h6-semibold">
      We will not collect any personal information about you except when specifically and knowingly provided by you.
    </p>

    <p class="h6-semibold">
      When you create an account, we will collect your first and last name, email address, street address, city, state,
      zip code, and phone number. We do this so we can find the closest pickup location, check if we offer home delivery
      in your zip code area, know where to ship your order, and if we need to contact you by email or phone regarding
      your order or account. We will not use your phone number for marketing purposes, only to contact you about your
      order or account.
    </p>

    <p class="h6-semibold">
      We consider your completion of creating an account as consent that we can send you marketing emails regarding our
      products and services.
    </p>

    <p class="h6-semibold">
      We also collect information about gift recipients so that we can fulfill the gift purchase.
    </p>

    <p class="h6-semibold">
      During checkout, we will also require you to provide a credit card. We do not collect your card number or card
      security code. We only collect and store the last four digits of your card number, the card brand, the
      cardholder's name, expiration date, and billing address. We do this so we can provide you with details on what
      cards you have provided and are using to pay for a particular order. See the section below titled “How we process
      credit cards” to learn more about how your card data is processed. When signing up for our newsletter will collect
      your email. We do this so we can send you our weekly newsletter.
    </p>

    <h4 class="h4-bold">
      How we use information
    </h4>

    <p class="h6-semibold">
      We use the information that we collect to fulfill any orders placed through our website, including processing your
      payment information, providing you with invoices, and/or order confirmations.
    </p>

    <h4 class="h4-bold">
      How we process credit cards
    </h4>

    <p class="h6-semibold">
      When you initially provide or update your payment information, we transmit it via an encrypted connection to our
      payment processor, Authorize (Authorize.net). Your credit card data never touches our servers, and your full card
      number and security code are never saved on our servers. When we charge your credit card, we send a request to
      Authorize, including the amount to charge, Authorize will then issue the charge on our behalf.
    </p>

    <h4 class="h4-bold">
      How we use cookies
    </h4>

    <p class="h6-semibold">
      Cookies are small files that a site or its service provider transfers to your computer's hard drive through your
      Web browser (if you allow) that enable the site's or service provider's systems to recognize your browser and
      capture and remember certain information. For instance, we use cookies to help us remember and process the items
      in your shopping cart. They are also used to help us understand your preferences based on previous or current site
      activity, which enables us to provide you with improved services. You can choose to have your computer warn you
      each time a cookie is being sent, or you can choose to turn off all
      cookies. You do this through your browser settings. Each browser is a little different, so look at your browser's
      Help menu to learn the correct way to modify your cookies.
    </p>

    <p class="h6-semibold">
      If you disable cookies, some features will be disabled, and some of our services will not function properly.
    </p>

    <h4 class="h4-bold">
      How we work with third parties
    </h4>

    <p class="h6-semibold">
      We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information. This
      does not include website hosting partners and other parties who assist us in operating our website, conducting our
      business, or serving our users, so long as those parties agree to keep this information confidential. We may also
      release information when its release is appropriate to comply with the law, enforce our site policies, or protect
      ours or others' rights, property, or safety.
    </p>

    <h4 class="h4-bold">
      Do-not-track signal
    </h4>

    <p class="h6-semibold">
      We honor Do Not Track signals and Do Not Track when a Do Not Track (DNT) browser mechanism is in place. Should you
      not wish to be tracked, please select the Do Not Track option from your internet browser.
    </p>

    <h4 class="h4-bold">
      Rights to control your personal information
    </h4>

    <p class="h6-semibold">
      If you’ve registered an account, you can access, review, and manage many of your details directly in your account
      settings. To reach these settings, click on your name in the top right corner of the site.
    </p>

    <p class="h6-semibold">
      You can unsubscribe from our newsletter by sending your request to <a
        href="mailto:info@carltonfarm.com">{{'info@carltonfarm.com'}}</a>.
    </p>

    <h4 class="h4-bold">
      Data retention
    </h4>

    <p class="h6-semibold">
      We will store your data indefinitely until you request us to delete your data. To contact us please send an email
      to <a href="mailto: info@carltonfarm.com">{{'info@carltonfarm.com'}}</a>
    </p>

    <h4 class="h4-bold">
      COPPA (Children's Online Privacy Protection Act)
    </h4>

    <p class="h6-semibold">
      When it comes to the collection of personal information from children under 13, the Children's Online Privacy
      Protection Act (COPPA) puts parents in control. The Federal Trade Commission, the nation's consumer protection
      agency, enforces the COPPA Rule, which spells out what operators of websites and online services must do to
      protect children's privacy and safety online.
    </p>

    <p class="h6-semibold">
      We do not specifically market to children under the age of 13 years. If we become aware that we have collected
      personally identifiable information from someone under the age of thirteen, we will remove that child’s personal
      information from our database.
    </p>

    <h4 class="h4-bold">
      Fair Information Practices
    </h4>

    <p class="h6-semibold">
      In order to be in line with Fair Information Practices, we will take the following responsive action: should a
      data breach occur, we will notify you via email within 7 business days.
    </p>

    <p class="h6-semibold">
      We also agree to the Individual Redress Principle, which requires that individuals have the right to legally
      pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle
      requires not only that individuals have enforceable rights against data users, but also that individuals have
      recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.
    </p>

    <h4 class="h4-bold">
      CAN-SPAM Act
    </h4>

    <p class="h6-semibold">
      The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial
      messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough
      penalties for violations.
    </p>

    <p class="mb-0 h6-semibold">
      We collect your email address in order to:
    </p>

    <ul>
      <li class="h6-semibold">
        Send information, respond to inquiries, and/or other requests or questions.
      </li>
      <li class="h6-semibold">
        Process orders and/or send information and updates pertaining to orders.
      </li>
      <li class="h6-semibold">
        Send you additional information related to your product and/or service.
      </li>
      <li class="h6-semibold">
        Market to our mailing list or continue to send emails to our clients after the original transaction has
        occurred.
      </li>
    </ul>

    <p class="mb-0 h6-semibold">
      To be in accordance with CAN-SPAM, we agree to the following:
    </p>

    <ul>
      <li class="h6-semibold">
        Not use false or misleading subjects or email addresses.
      </li>
      <li class="h6-semibold">
        Identify the message as an advertisement in some reasonable way.
      </li>
      <li class="h6-semibold">
        Include the physical address of our business or site headquarters.
      </li>
      <li class="h6-semibold">
        Monitor third-party email marketing services for compliance, if one is used.
      </li>
      <li class="h6-semibold">
        Honor opt-out/unsubscribe requests quickly.
      </li>
      <li class="h6-semibold">
        Allow users to unsubscribe by using the link at the bottom of each email.
      </li>
    </ul>

    <p class="h6-semibold">
      If at any time you would like to unsubscribe from receiving future emails, you can email us at <a
        href="mailto: info@carltonfarm.com">{{'info@carltonfarm.com'}}</a>, and we will promptly remove you from all
      correspondence.
    </p>

    <h4 class="h4-bold">
      Communication via SMS text
    </h4>

    <p class="h6-semibold">
      In addition to email, we send SMS text messages to cellular phone numbers to alert customers of deliveries and
      other communications. Recipients of SMS text messages can opt out at any time by texting “STOP” to Carlton Farms
      generated SMS text message.
    </p>

    <h4 class="h4-bold">
      Contacting Us
    </h4>

    <p class="h6-semibold">
      If there are any questions regarding this privacy policy, you may contact us using the information below:
    </p>

    <p class="h6-semibold">
      <a href="mailto: info@carltonfarm.com">{{'info@carltonfarm.com'}}</a> or by calling us at 770-655-1503.
    </p>

    <p class="h6-semibold">
      Carlton Farms
    </p>

    <p class="h6-semibold">
      1276 Cartersville Hwy
    </p>

    <p class="h6-semibold">
      Rockmart, GA 30153
    </p>

    <p class="h6-semibold">
      770-655-1503
    </p>

  </div>

</section>